import moment, { Moment } from "moment";

export const startOfTheMonth = (year?: number, month?: number): Moment => {
  const today = moment();
  if (year) today.year(year);
  if (month !== undefined && month !== null) today.month(month);
  return today.startOf("month");
};

export const endOfTheMonth = (year?: number, month?: number): Moment => {
  const today = moment();
  if (year) today.year(year);
  if (month !== undefined && month !== null) today.month(month);
  return today.endOf("month");
};

export const startOfTheDay = (
  day?: number,
  year?: number,
  month?: number
): Moment => {
  const today = moment();
  if (day) today.day(day);
  if (year) today.year(year);
  if (month !== undefined && month !== null) today.month(month);
  const startOfDay = today.startOf("day");
  return startOfDay;
};

export const endOfTheDay = (
  day?: number,
  year?: number,
  month?: number
): Moment => {
  const today = moment();
  if (day) today.day(day);
  if (year) today.year(year);
  if (month !== undefined && month !== null) today.month(month);
  const endOfDay = today.endOf("day");
  return endOfDay;
};

export const formatDate = (date: string, pattern?: string): string => {
  return moment(date).format(pattern || "MM/DD/YYYY");
};

export function formatDateTime(date: Date): string {
  return date.toLocaleString(undefined, {
    year: "numeric",
    month: "short",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  });
}
